/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Guestlist_Timeline_OpenedInputs */

const en_scene_guestlist_timeline_opened = /** @type {(inputs: Scene_Guestlist_Timeline_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opened the invitation`)
};

/**
* | output |
* | --- |
* | "Opened the invitation" |
*
* @param {Scene_Guestlist_Timeline_OpenedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_guestlist_timeline_opened = /** @type {((inputs?: Scene_Guestlist_Timeline_OpenedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Guestlist_Timeline_OpenedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_guestlist_timeline_opened(inputs)
});